<template>
  <div>
    <div v-if="isEditing">
      <el-input size="mini" v-model="labelShow">
        <el-button slot="append" title="确认" icon="el-icon-check" @click="handleEdited"></el-button>
      </el-input>
    </div>
    <div class="checkbox-container" v-else>
      <el-checkbox style="margin: 0 10px;" v-model="modelValue"  :indeterminate="indeterminateValue" @change="handleStatusChange" v-if="type == 'checkbox'">{{
        labelShow
      }}</el-checkbox>
      <el-radio v-model="modelValue" @change="handleStatusChange" v-if="type == 'radio'">{{
        labelShow
      }}</el-radio>
      <i class="el-icon-edit" @click="handleEdit" title="修改"></i>
      <i class="el-icon-delete" @click="handleDel" title="删除"></i>
    </div>
  </div>
</template>

<script>
/*
三个事件，statusChange，labelChange，del
statusChange 是否选中
labelChange 标签文字改变
del 删除这个标签
*/
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    canDel: {
      type: Boolean,
      default: true,
    },
    label: String,
    type: {
      type: String,
      default: "checkbox",
    },
    editing:{
      type:Boolean,
      default:false
    },
    indeterminate:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      isEditing: this.$props.editing,
      modelValue:this.$props.value,
      labelShow: this.$props.label,
      indeterminateValue: this.$props.indeterminate
    };
  },
  watch: {
    // 直接监听 editing 属性
    editing(newVal, oldVal) {
      this.isEditing = newVal
    }
  },
  methods: {
    handleEdit() {
      this.isEditing = true;
      this.$emit("isEditingChange",this.isEditing);
    },
    handleEdited() {
      this.$emit("labelChange",this.labelShow);
    },
    handleClose() {
      this.labelShow = this.$props.label
      this.isEditing = false;
    },
    handleStatusChange(){
      this.$emit("statusChange",this.modelValue);
      this.$emit("input",this.modelValue);
    },
    handleDel() {
      this.$emit("del");
    },
  },
};
</script>

<style scoped>
.checkbox-container i{
  display: none;
  margin-left: .5em;
  color: #333;
  cursor: pointer;
}
.checkbox-container:hover{
  background-color: rgb(236, 245, 255);    
  padding-right: 10px;
  border-radius: 4px;
}
.checkbox-container:hover i{
  display: inline-block;
  /* visibility:visible; */
}
</style>
